/* eslint-disable import/prefer-default-export */
export const SET_HIERARCHY_NODES = 'SET_HIERARCHY_NODES';
